<template>
  <div v-if="profile" class="" style="height: 100%;">
    <span v-if="me && me.company_type == 'agency'" class="show-chatbot-yes"></span>

    <dialog-add-business v-if="me" ref="dialogAddBusiness" :is_business="me.company_type == 'agency' ? false : true"></dialog-add-business>
    
    <v-app-bar v-if="showHeaderAndNav" app color="" class="header-top" elevation="0" v-on-clickaway="clickedOutsideUserMenu">
      <!-- <i class="fa fa-chart-bar" style="font-size: 30px; cursor: pointer;"></i> -->

      <router-link v-if="me" v-show="$router.currentRoute.name == 'onboarding'" to="/" class="">
        <img v-if="!$agency" src="https://reviewgrower.com/wp-content/uploads/2021/09/reviewgrower-blue-green-middle-e1652210601332.png" alt="" style="height: 32px;">
        <span v-if="$agency" style="color: white; font-size: 18px;">
          <span v-if="!$agency.logo" alt="" style="height: 32px; color: #000000 !important;">
            <img v-if="me.company_type == 'agency'" src="https://reviewgrower.com/wp-content/uploads/2021/09/reviewgrower-blue-green-middle-e1652210601332.png" alt="" style="height: 32px;" />
            <span v-else>{{ $agency.company_name }}</span>
            </span>
          <!-- <span v-if="!$agency.favicon" style="padding-top; 2px; color: #000000 !important;">{{ $agency.company_name }}</span> -->
          <img v-if="$agency.logo" :src="$agency.logo" alt="" style="height: 32px;">
        </span>
      </router-link>

      <v-app-bar-nav-icon v-show="$router.currentRoute.name != 'onboarding'" @click.stop="sidebarMenu = !sidebarMenu"></v-app-bar-nav-icon>
      
      <div v-show="$router.currentRoute.name != 'onboarding'" class="flex flex-row items-center justify-between flex-wrap mt-1" style="min-height: 60px;" v-on-clickaway="clickedOutsideLocationsDd">
        <div class="header-right-part">

          <div class="relative">
            <br clear="all" />

              <template v-if="me && !$store.state.auth.is_location">
                <div class="header-right-items">

                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    hide-details
                    v-model="search_locations"
                    class="locations-dropdown"
                    outlined
                    dense
                    @focus="showLocationsDd();"
                    @keyup="calculateFilteredLocations()"
                  >
                    
                  </v-text-field>

                  <div v-show="show_locations_dd" style="position: absolute; padding: 20px; background: #FFFFFF; border-radius: 10px; max-width: 100%; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); min-width: 280px;">
                    <div v-if="profile">
                      <div class="locations-links" v-if="me.company_type != 'agency'">
                        <router-link to="/locations" @click="show_locations_dd = false" style="font-size: 12px;"><i class="mdi mdi-map-marker"></i> Manage Locations</router-link>
                        &nbsp;&nbsp;&nbsp;
                        <a href="javascript: void(0);" style="font-size: 12px;" @click="show_locations_dd = false; $refs.dialogAddBusiness.show()"><i class="fa fa-plus"></i> Add Location</a>
                      </div>

                      <div v-if="me.company_type == 'agency'" class="locations-links">
                        <router-link to="/businesses" @click="show_locations_dd = false" style="font-size: 12px;" v-if="sectionEnabled('/businesses')"><i class="mdi mdi-map-marker"></i> View All Businesses</router-link>
                        &nbsp;&nbsp;&nbsp;
                        <a href="javascript: void(0);" style="font-size: 12px;" @click="show_locations_dd = false; $refs.dialogAddBusiness.show()" v-if="profile.settings.role != 'Manager (readonly)'"><i class="fa fa-plus"></i> Add Business</a>
                      </div>
                    </div>

                    <template>
                      <div style="max-height: 350px; overflow: auto;">
                        <div v-for="(item, index) in filtered_locations" :key="'location-' + index">
                          <a href="javascript: void(0);" @click="switchLocation(item.value)" :style="((me.uuid == item.value && 0) ? '' : 'color: #000000 !important;')">
                            <template v-if="me.company_type == 'admin'">
                              <template v-if="item.type == 'agency'">
                                <strong style='font-size: 16px;' v-html="'<i class=\'fa fa-building\'></i>&nbsp; ' + item.name"></strong>
                              </template>
                              <template v-if="item.type == 'business'">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                              <template v-if="item.type == 'location'">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                            </template>

                            <template v-if="me.company_type == 'agency'">
                              <template v-if="item.type == 'business'">
                                <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                              <template v-if="item.type == 'location'">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                              </template>
                            </template>

                            <template v-if="me.company_type == 'business' || me.company_type == 'location'">
                              <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name + ((item.cid) ? ' - ' + item.cid : '')"></span>
                            </template>
                          </a>
                        </div>
                      </div>
                    </template>
                  </div>

                  <v-combobox
                    v-if="!fetchingLocations && !fetchingStats && 0"
                    v-model="me.uuid"
                    label=""
                    :items="locations"
                    item-text="name"
                    item-value="value"
                    hide-no-data
                    return-object
                    outlined
                    dense
                    hide-details
                    @change="switchLocation(me.uuid)"
                    class="locations-dropdown"
                    prepend-inner-icon="mdi-magnify"
                    append-icon="mdi-chevron-down"
                    @click="checkLocationsLinksDone()"
                  >
                    <template v-slot:item="{ item }">
                      <template v-if="me.company_type == 'admin'">
                        <template v-if="item.type == 'agency'">
                          <strong style='font-size: 16px;' v-html="'<i class=\'fa fa-building\'></i>&nbsp; ' + item.name"></strong>
                        </template>
                        <template v-if="item.type == 'business'">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name"></span>
                        </template>
                        <template v-if="item.type == 'location'">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name"></span>
                        </template>
                      </template>

                      <template v-if="me.company_type == 'agency'">
                        <template v-if="item.type == 'business'">
                          <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-briefcase-outline\'></i>&nbsp; ' + item.name"></span>
                        </template>
                        <template v-if="item.type == 'location'">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name"></span>
                        </template>
                      </template>

                      <template v-if="me.company_type == 'business' || me.company_type == 'location'">
                        <span style='font-size: 12px;' v-html="'<i class=\'mdi mdi-map-marker\'></i>&nbsp; ' + item.name"></span>
                      </template>
                    </template>
                  </v-combobox>

                  <div v-if="fetchingLocations || fetchingStats" style="">
                    <i class="fa fa-spin fa-spinner mt-2" style="color: #FFFFFF; font-size: 24px;"></i>
                  </div>
                </div>
              </template>
          </div>

        </div>
      </div>
      
      <v-spacer></v-spacer>

      <div v-show="$router.currentRoute.name != 'onboarding'" class="header-stats pt-1" v-if="me && me.company_type == 'agency' && !fetchingLocations && !fetchingStats">
        <i class="fa fa-briefcase"></i>&nbsp; <strong>{{ stats.stats.total_businesses }}</strong> Business<span v-if="stats.stats.total_businesses != 1">es</span>
        &nbsp;&nbsp;&nbsp;
        <i class="fa fa-map-marker"></i>&nbsp; <strong>{{ stats.stats.total_locations }}</strong> Location<span v-if="stats.stats.total_locations != 1">s</span>
      </div>

      <v-spacer v-if="me && me.settings && me.settings.onboarding_percentage < 100 && me.settings.onboarding_status != 1"></v-spacer>

      <div style="position: relative; cursor: pointer;" v-if="me && me.settings && me.settings.onboarding_percentage < 100 && me.settings.onboarding_status != 1">
        <div style="float: left;" @click="toggleOnboarding()">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path d="M16.1088 22.0407L9.26571 28.8838C9.18832 28.9612 9.08658 29 8.98514 29C8.88371 29 8.78196 28.9612 8.70458 28.8838C8.5498 28.729 8.5498 28.4777 8.70458 28.3226L15.5476 21.4796C15.7027 21.3245 15.9537 21.3245 16.1088 21.4796C16.2639 21.6346 16.2639 21.8856 16.1088 22.0407ZM17.2196 24.8664L13.7634 28.3226C13.6083 28.4774 13.6083 28.7287 13.7634 28.8838C13.8408 28.9612 13.9426 29 14.044 29C14.1454 29 14.2472 28.9612 14.3246 28.8838L17.7808 25.4275C17.9359 25.2725 17.9359 25.0215 17.7808 24.8664C17.626 24.7116 17.3747 24.7116 17.2196 24.8664ZM8.52051 13.8913C8.36543 13.7362 8.11446 13.7362 7.95938 13.8913L1.11631 20.7344C0.961229 20.8895 0.961229 21.1404 1.11631 21.2955C1.1937 21.3729 1.29544 21.4117 1.39688 21.4117C1.49832 21.4117 1.60006 21.3729 1.67745 21.2955L8.52051 14.4524C8.67529 14.2974 8.67529 14.0461 8.52051 13.8913ZM1.39688 16.3526C1.49832 16.3526 1.60006 16.3137 1.67745 16.2364L5.13367 12.7801C5.28875 12.6251 5.28875 12.3741 5.13367 12.219C4.97889 12.0642 4.72761 12.0642 4.57253 12.219L1.11631 15.6752C0.961229 15.8303 0.961229 16.0813 1.11631 16.2364C1.1937 16.3137 1.29544 16.3526 1.39688 16.3526ZM27.8198 7.32295C26.9562 9.3381 25.6518 11.3076 23.9422 13.1766C23.4208 13.7467 22.86 14.3075 22.2631 14.8591C22.625 16.3227 22.6682 17.7227 22.3836 19.0226C22.0183 20.6906 21.1174 22.1979 19.7059 23.5021C19.6316 23.5709 19.5348 23.6076 19.4364 23.6076C19.3951 23.6076 19.3532 23.6011 19.3128 23.5878C19.1759 23.5428 19.0742 23.4272 19.047 23.2857C18.7131 21.5483 18.1467 20.0743 17.2835 18.6782C16.7787 19.0047 16.2648 19.3281 15.7308 19.6445C15.6679 19.6818 15.5982 19.7 15.5288 19.7C15.4262 19.7 15.3247 19.6602 15.2483 19.5837L14.6495 18.985C13.3561 20.451 11.5025 21.1343 10.0402 21.1343C9.76056 21.1343 9.49541 21.1093 9.25091 21.0603C9.09429 21.0288 8.97189 20.9064 8.94013 20.7498C8.63366 19.2282 9.26818 16.8915 11.0148 15.3506L10.4167 14.7524C10.2887 14.6245 10.2634 14.4256 10.3559 14.2699C10.6719 13.7359 10.9954 13.2219 11.3222 12.7172C9.92581 11.854 8.45176 11.2879 6.71471 10.954C6.57319 10.9268 6.45757 10.8251 6.41256 10.6882C6.36754 10.5513 6.40023 10.4009 6.49827 10.2951C7.80245 8.88395 9.30949 7.98305 10.9778 7.61739C12.2776 7.3325 13.6777 7.37598 15.1413 7.73794C15.6926 7.14104 16.2537 6.58021 16.8238 6.05885C18.6925 4.34832 20.662 3.04353 22.6771 2.18024C26.1408 0.696318 28.5247 1.02652 28.6245 1.04132C28.7975 1.06691 28.9332 1.20257 28.9588 1.37554C28.9736 1.47543 29.3038 3.85964 27.8198 7.32295ZM25.5802 2.06894C25.83 3.24609 26.7558 4.17134 27.933 4.42015C28.2089 3.1724 28.2188 2.253 28.1985 1.80255C27.7474 1.78313 26.8252 1.79485 25.5802 2.06894ZM11.7584 12.0525C12.651 10.7277 13.5806 9.51415 14.541 8.41253C11.8633 7.86157 9.52686 8.50318 7.58138 10.3275C9.12019 10.6922 10.4694 11.2521 11.7584 12.0525ZM14.0872 18.4223L11.5775 15.9126C10.1774 17.1292 9.53703 19.0007 9.677 20.3228C10.9994 20.4634 12.8708 19.8224 14.0872 18.4223ZM21.5875 15.4591C20.4859 16.4198 19.2724 17.3491 17.9476 18.2416C18.7477 19.5307 19.3076 20.8796 19.6726 22.4184C21.4975 20.4729 22.1388 18.1371 21.5875 15.4591ZM27.0904 7.01062C27.3694 6.35915 27.5797 5.7493 27.7388 5.18909C26.2795 4.86814 25.1332 3.72182 24.8116 2.26287C24.2335 2.42628 23.6042 2.64333 22.9315 2.93469C19.9356 4.23208 15.4835 7.27547 11.1964 14.4093L15.5911 18.804C22.7585 14.4962 25.8004 10.0216 27.0904 7.01062ZM22.7924 7.20764C23.8694 8.28458 23.8694 10.0367 22.7924 11.1134C22.2541 11.6517 21.5469 11.9212 20.8396 11.9212C20.1323 11.9212 19.425 11.652 18.8867 11.1134C17.8098 10.0364 17.8098 8.28427 18.8867 7.20764C19.9633 6.13069 21.7158 6.13069 22.7924 7.20764ZM22.2316 7.76846C21.8478 7.38461 21.3437 7.19284 20.8396 7.19284C20.3355 7.19284 19.8314 7.38461 19.4475 7.76846C18.6801 8.53586 18.6801 9.78485 19.4475 10.5522C20.2149 11.3196 21.4639 11.3196 22.2313 10.5522C22.999 9.78485 22.9987 8.53617 22.2316 7.76846Z" fill="#2477F6" fill-opacity="0.7" stroke="#2477F6" stroke-opacity="0.7" stroke-width="0.4"/>
          </svg>
        </div>

        <div style="float: left;" @click="toggleOnboarding()">
          <div style="margin-top: 2px; padding-left: 7px; color: #2477F6;">
            {{ parseFloat(me.settings.onboarding_percentage).toFixed(0) }}%
          </div>
        </div>

        <div v-show="showOnboarding" style="position: absolute; background: #FFFFFF; box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.10); padding: 20px; width: 480px; right: 0px; margin-top: 35px;">
          <div style="font-size: 20px; font-weight: bold; padding-bottom: 10px;">Complete Your Profile</div>
          <div style="font-size: 16px; color: rgba(0, 0, 0, 0.60); padding-bottom: 20px;">Complete all steps below</div>

          <v-progress-linear
            rounded
            :value="parseFloat(me.settings.onboarding_percentage)"
            color="#2477F6"
            background-color="grey lighten-4"
            height="10"
          ></v-progress-linear>

          <div  v-for="(item, index) in me.settings.onboarding_items" :key="index" style="padding-top: 20px;" @click="$router.push('/onboarding')">
            <div style="float: left;">
              <svg v-if="item.status == 'completed'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#2477F6"/>
                <path d="M8.57755 13.5796C8.37755 13.5796 8.18755 13.4996 8.04755 13.3596L5.2175 10.5296C4.9275 10.2396 4.9275 9.75961 5.2175 9.46961C5.5075 9.17961 5.9875 9.17961 6.2775 9.46961L8.57755 11.7696L13.7175 6.62961C14.0075 6.33961 14.4875 6.33961 14.7775 6.62961C15.0675 6.91961 15.0675 7.39961 14.7775 7.68961L9.10755 13.3596C8.96755 13.4996 8.77755 13.5796 8.57755 13.5796Z" fill="white"/>
              </svg>
              <svg v-if="item.status == 'pending'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="10" fill="#B9BDC7"/>
                <circle cx="10" cy="10" r="5" fill="white"/>
              </svg>
            </div>

            <div style="float: left; padding-left: 15px;">
              {{ index + 1 }}. 

              <span v-if="item.status == 'pending'" style="color: rgba(0, 0, 0, 0.30);">
                {{ item.title }}
              </span>

              <span v-if="item.status == 'completed'" style="text-decoration: line-through;">
                {{ item.title }}
              </span>
            </div>

            <div style="float: right;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10 17L15 12.5L10 8" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            
            <div style="clear: both;"></div>
          </div>
        </div>
      </div>

      <v-divider
          class="mx-4"
          vertical
        ></v-divider>
  
      <div style="position: relative;">
        <div class="flex" @click="toggleUserMenu()" style="cursor: pointer;">
          <a class="me-icon mr-2 rounded-full text-white shadow-inner focus:outline-none zoom" style="width: 40px; display: block; text-align: center;">
            <v-gravatar v-if="profile" class="gravatar-pic" :email="profile.email" default-img="https://regro-cdn.s3.amazonaws.com/images/profile_image.png" />
          </a>
          <div v-if="profile" style="line-height: 20px;">
            <span class="me-icon-name">
              {{ profile.first_name }} {{ profile.last_name }}
            </span>
            <br />

            <span class="me-icon-email">
              {{ profile.email }}
            </span>

            <div class="me-icon-email">
              <strong>{{ profile.company_name }}</strong>
            </div>
          </div>
          <div class="ml-3" style="line-height: 40px;">
            <i class="mdi mdi-chevron-down me-icon-icon"></i>
          </div>
        </div>
        <div v-if="showUserMenu" class="rounded-lg bg-white shadow-md absolute min-w-full mt-3 right-0 user-menu p-6" style="z-index: 99;">
          <div class="flex" style="cursor: pointer;">
            <a class="me-icon mr-2 rounded-full text-white shadow-inner focus:outline-none zoom" style="width: 40px; display: block; text-align: center;">
              <v-gravatar v-if="profile" class="gravatar-pic" :email="profile.email" default-img="https://regro-cdn.s3.amazonaws.com/images/profile_image.png" />
            </a>
            <div v-if="profile" style="line-height: 20px;">
              <span class="me-icon-name">
                {{ profile.first_name }} {{ profile.last_name }}
              </span>
              <br />

              <span class="me-icon-email">
                {{ profile.email }}
              </span>

              <div class="me-icon-email">
                <strong>{{ profile.company_name }}</strong>
              </div>
            </div>
          </div>

          <v-divider class="mt-3 mb-3"></v-divider>

            <ul class="me-icon-menu list-reset">
              <li><router-link to="/user-settings" class="py-1 block"><i class="mdi mdi-account-outline mr-1" style="font-size: 16px;"></i> Edit Profile</router-link></li>
              <li v-if="shouldShowBilling()"><router-link to="/billing" class="py-1 block"><i class="mdi mdi-credit-card-outline mr-1" style="font-size: 16px;"></i> Billing</router-link></li>

              <li v-if="$store.state.auth.owner && me.company_type != 'admin' && me.company_type != 'agency'"><a href="javascript: void(0);" @click="backToAgencyAdmin()" class="py-1 block font-medium whitespace-no-wrap" style="color: #f56565 !important;"><i class="fa fa-angle-double-left -mr-1"></i> Back to Agency Dashboard</a></li>

              <li v-if="$store.state.auth.admin && me.company_type != 'admin'"><a href="javascript: void(0);" @click="backToAdmin()" class="py-1 block font-medium whitespace-no-wrap" style="color: #f56565 !important;"><i class="fa fa-angle-double-left -mr-1"></i> Back to Administration</a></li>

              <v-divider  class="mt-3 mb-3"></v-divider>
              <li><a href="#" class="py-1 block logout-link ml-1" @click="logout" style="font-size: 12px !important; font-weight: bold;"><i class="fa fa-sign-out-alt -mr-3"></i> Sign Out</a></li>
            </ul>
        </div>
      </div>
      
    </v-app-bar>

    <v-navigation-drawer 
      v-show="$router.currentRoute.name != 'onboarding'"
      v-if="showHeaderAndNav"
      v-model="sidebarMenu" 
       class="rg-sidebar-left"
      app
      floating
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
      :width="250"
      >
      <v-list dense color="" dark>
          <v-list-item class="ml-7" style="opacity: 1;">
              <v-list-item-content>
                  <v-list-item-title>
                      <router-link to="/" class="">
                        <img v-if="!$agency" src="@/assets/logo.png" alt="" style="height: 32px;">
                        <span v-if="$agency" style="color: white; font-size: 18px;">
                          <span v-if="!$agency.logo" style="padding-top; 2px;">{{ $agency.company_name }}</span>
                          <img v-if="$agency.logo" :src="$agency.logo" alt="" style="height: 32px;">
                        </span>
                      </router-link>
                  </v-list-item-title>
              </v-list-item-content>
          </v-list-item>
      </v-list>

      <v-list class="-mt-4">
          <div v-if="me && me.company_type == 'admin'">
            <v-list-item v-for="item in menu_items.admin" :key="item.title" link :to="item.route" :href="item.href" :target="item.target">
                <v-list-item-icon style="padding-left: 26px; text-align: center;">
                    <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
          </div>

          <div v-if="me && me.company_type == 'agency'">
            <span v-for="item in menu_items.agency" :key="item.title">
              <v-list-item link :to="item.route" :href="item.href" :target="item.target" v-if="displayNavigationItem(item)">
                <v-list-item-icon style="padding-left: 26px; text-align: center;">
                    <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>
          </div>

          <template v-if="me && (me.company_type == 'business' || me.company_type == 'location')">
            <template v-for="item in menu_items.business">
              <span v-if="item.sub_nav" :key="item.title">
                <v-list-group
                  no-action
                  :key="item.title"
                  style="position: relative;"
                >
                  <template v-slot:activator>
                    <v-list-item v-if="displayNavigationItem(item)" :sub-nav-parent="item.route"
                      :style="((me.subscription.product_details.limits.permissions[item.route]) ? '' : 'opacity: 1')"
                    >
                      <v-list-item-icon style="padding-left: 26px; text-align: center;" @click="$router.push(item.sub_nav[0].route).catch(()=>{});">
                          <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                      </v-list-item-icon>
                      <v-list-item-content @click="$router.push(item.sub_nav[0].route).catch(()=>{});">
                          <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <div style="background: #FFFFFF; opacity: 0.2; position: absolute; left: 44px; width: 1px; top: 76px; bottom: 30px; z-index: 2;">

                  </div>

                  <v-list-item
                    v-for="(child, index) in item.sub_nav"
                    :key="index"
                    link
                    :to="child.route"
                    style="position: relative; z-index: 3;"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="color: #FFFFFF; font-size: 14px;"
                        :style="(($router.currentRoute.path == child.route) ? 'opacity: 1;' : 'opacity: 0.5')"
                      >
                        <div style="float: left; border-radius: 10px; width: 10px; position: relative; z-index: 3; height: 10px; margin-top: 9px; margin-right: 16px; margin-left: 36px;"
                          :style="(($router.currentRoute.path == child.route) ? 'background: #3EBB80;' : 'background: #FFFFFF;')"
                        ></div>
                        <div class="sub_nav_text" style="float: left; border-radius: 5px; padding: 7px; padding-left: 12px; width: calc(100% - 90px);"
                          :style="(($router.currentRoute.path == child.route) ? 'background: #242E44;' : '')"
                        >
                          {{ child.title }}
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  
                </v-list-group>
              </span>
              <span v-else :key="item.section">
                <v-list-item link :to="item.route" :href="item.href" :target="item.target" v-if="displayNavigationItem(item)"
                  :style="((me.subscription.product_details.limits.permissions[item.route]) ? '' : 'opacity: 1')"
                >
                  <v-list-item-icon style="padding-left: 26px; text-align: center;">
                      <i :class="item.icon" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </span>
            </template>

            <template v-if="$agency && $agency.settings.members_area_enabled">
              <span>
                <v-list-item :to="'/members-area'"
                  >
                  <v-list-item-icon style="padding-left: 26px; text-align: center;">
                      <i class="mdi mdi-wallet-membership" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title class="white--text">{{ $agency.settings.members_area_nav_text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </span>
            </template>

            <!-- <span v-if="hasGridTrackerEnabled()">
              <v-list-item :to="'/grid-tracker-list'">
                <v-list-item-icon style="padding-left: 26px; text-align: center;">
                    <i class="mdi mdi-map-marker-multiple-outline" style="color: white; font-size: 20px; margin-top: -3px;"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="white--text">Grid Tracker</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span> -->
          </template>
      </v-list>
  </v-navigation-drawer>

  <div v-if="!showHeaderAndNav" style="height: 100%;">
    <div v-if="hasAccess" style="height: 100%;">
      <slot v-if="me && me.status == 1"></slot>
      <div v-if="me && me.status == 0" class="">
        Your access has been disabled. Please contact your account owner.
      </div>
    </div>
    
    <div v-if="me && !hasAccess">
        You do not have access to this section. In order to get access, please contact your account manager.
      </div>
  </div>

  <v-container v-else class="rg-container fill-height" fluid :style="((inbox == true && hasAccess) ? 'padding: 0px !important; margin: 0px !important;' : 'padding: 40px;')">
      <v-row class="fill-height">
          <v-col>
              <div v-if="hasAccess">
                <slot v-if="me && me.status == 1"></slot>
                <div v-if="me && me.status == 0" class="">
                  Your access has been disabled. Please contact your account owner.
                </div>
              </div>
              
              <div v-if="me && !hasAccess">
                  You do not have access to this section. In order to get access, please contact your account manager.
                </div>
          </v-col>
      </v-row>
  </v-container>

  </div>



</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway';
import dialogAddBusiness from '@/components/dialogs/businesses/addBusiness.vue'

export default {
  mixins: [ clickaway ],

  props: ['inbox'],

  data: function() {
    return {
      show_locations_dd: false,

      showUserMenu: false,
      showOnboarding: false,
      loaded: false,
      locations_links_visible: false,
      locations_links_done: false,

      search_locations: "",
      filtered_locations: [],

      drawer: false,
      group: null,

      sidebarMenu: true,
      toggleMini: false,
      menu_items: {
        admin: [
          { title:"Dashboard", route:"/dashboard", icon: "mdi mdi-view-dashboard-outline" },
          { title:"Agencies", route:"/agencies", icon: "mdi mdi-briefcase-outline" }
        ],
        agency: ((this.$agency && this.$agency.settings.is_omni) ?
          [
            { title:"Dashboard", section: '/dashboard', route:"/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
            { title:"Businesses", section: '/businesses', route:"/businesses", icon: "mdi mdi-briefcase-outline", only_owner: false },
            { title:"Agency Settings", section: '/agency-settings', route:"/agency-settings", icon: "mdi mdi-cog-outline", only_owner: false },
            { title:"Users", section: '/users', route:"/users", icon: "mdi mdi-account-multiple", only_owner: true },
            { title:"Help", section: '/help', href:"mailto: support@revulab.io", icon: "mdi mdi-help-circle-outline", only_owner: false },
          ]
          :
          [
            { title:"Dashboard", section: '/dashboard', route:"/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
            { title:"Businesses", section: '/businesses', route:"/businesses", icon: "mdi mdi-briefcase-outline", only_owner: false },
            { title: "Reviews", section: "/reviews", "route": "/reviews", icon: "mdi mdi-calendar-star-outline", only_owner: false },
            // { title:"Sales Resources", section: '/resources', route:"/resources", icon: "mdi mdi-text-box-outline", only_owner: false },
            // { title:"Local Recon", section: '/local-recon', route:"/local-recon/dashboard", icon: "mdi mdi-web", only_owner: false },
            { title:"Agency Settings", section: '/agency-settings', route:"/agency-settings", icon: "mdi mdi-cog-outline", only_owner: false },
            { title:"Users", section: '/users', route:"/users", icon: "mdi mdi-account-multiple", only_owner: true },
            { title:"Help", section: '/help', href:"mailto: support@revulab.io", icon: "mdi mdi-help-circle-outline", only_owner: false },
          ]
        ),
        business: ((this.$agency && this.$agency.settings.is_omni) ?
          [
          { title: "Dashboard", section: "/dashboard", "route": "/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
          { title: "Contacts", section: "/contacts", route: "/contacts", icon: "mdi mdi-account-multiple-outline", only_owner: false, 
              sub_nav: [
                    { title: "Main", section: '/contacts-main', "route": "/contacts" },
                    { title: "Campaigns", section: '/contacts/campaigns', "route": "/contacts/campaigns" },
                    { title: "Bulk Actions", section: '/contacts/bulk-actions', "route": "/contacts/bulk-actions" }
                  ]
            },

            { title: "Widgets", section: "/widgets/contact", route: "/widgets/contact", icon: "mdi mdi-widgets-outline", only_owner: false },
            { title: "Calls", section: "/widgets/contact/calls", route: "/widgets/contact/calls", icon: "mdi mdi-phone-outline", only_owner: false },
            { title: "Settings", section: "/settings", route: "/settings", icon: "mdi mdi-message-star-outline", only_owner: false },
          ]
          :
          [
            { title: "Dashboard", section: "/dashboard", "route": "/dashboard", icon: "mdi mdi-view-dashboard-outline", only_owner: false },
            { title: "Reviews", section: "/reviews", "route": "/reviews", icon: "mdi mdi-calendar-star-outline", only_owner: false },
            { title: "Review Platforms", section: "/review-platforms", route: "/review-platforms", icon: "mdi mdi-checkbox-multiple-blank-outline", only_owner: false },
            { title: "Widgets", section: "/widgets", route: "/widgets", icon: "mdi mdi-widgets-outline", only_owner: false,
              sub_nav: ((this.$agency && this.hasAddon('OmniTalk')) ? 
                  [
                    {
                      title: "Reviews",
                      route: "/widgets"
                    },
                    {
                      title: "OmniTalk",
                      route: "/widgets/contact"
                    }
                  ] 
                  
                    :

                  [
                    {
                      title: "Reviews",
                      route: "/widgets"
                    }
                  ]
                )
            },
            { title: "Contacts", section: "/contacts", route: "/contacts", icon: "mdi mdi-account-multiple-outline", only_owner: false, 
              sub_nav: [
                  { title: "Main", section: '/contacts-main', "route": "/contacts" },
                  { title: "Campaigns", section: '/contacts/campaigns', "route": "/contacts/campaigns" },
                  { title: "Review Funnel", section: '/contacts/review-funnel', "route": "/review-funnel" },
                  { title: "Bulk Actions", section: '/contacts/bulk-actions', "route": "/contacts/bulk-actions" }
                ]
            },
            { title: "Feedback", section: "/feedback", route: "/feedback", icon: "mdi mdi-forum-outline", only_owner: false },
            { title: "Settings", section: "/settings", route: "/settings", icon: "mdi mdi-message-star-outline", only_owner: false },
            { title: "Email Signatures", section: "/email-signatures", route: "/email-signatures", icon: "mdi mdi-email", only_owner: false },
            { title: "Social Posting", section: "/social-posting", route: "/social-posting", icon: "mdi mdi-google-circles-extended", only_owner: false },
            // { title: "Grid Tracker", section: "/grid-tracker", route: "/grid-tracker-list", icon: "mdi mdi-map-marker-multiple-outline", only_owner: false },
            // { title: "Inbox", section: "/inbox", route: "/inbox", icon: "mdi mdi-message-processing", only_owner: false },
            // { title: "Users", section: '/users', route:"/users", icon: "mdi mdi-account-multiple", only_owner: true }
          ]
        )
      },
    }
  },
  components: {
    dialogAddBusiness
  },
  methods: {
    

    clickedOutsideLocationsDd() {
      this.show_locations_dd = false;
      this.search_locations = "";
      this.calculateFilteredLocations();
    },

    showLocationsDd() {
      let self = this;
      setTimeout(function() { self.show_locations_dd = true }, 100);
    },

    calculateFilteredLocations() {
        this.filtered_locations = [];

        for (var i in this.locations) {
          // console.log(this.locations[i].name);
          if (this.search_locations) {
            if (this.locations[i].name.toLowerCase().indexOf(this.search_locations.toLowerCase()) != -1) {
              this.filtered_locations.push(this.locations[i]);
            }
          }
          else {
            this.filtered_locations.push(this.locations[i]);
          }
        }
    },

    hasAddon(addon_name) {
      for (var i in this.$agency.addons) {
        if (this.$agency.addons[i].description == addon_name)
          return true;
      }
      return false;
    },
    toggleTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;      
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
      this.showOnboarding = false
    },
    toggleOnboarding() {
      this.showOnboarding = !this.showOnboarding
      this.showUserMenu = false
    },
    async logout() {
      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/add-activity`, {
        activity: "Logged out."
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let email = this.me.email
      try {
        await this.$store.dispatch('auth/logout')
        this.$router.push('/')

        setTimeout(function() {
          analytics.track('Signed Out', {
            username: email
          });
        }, 2000);

      } catch (e) {
        // console.log(e)
      }
    },
    async switchLocation(email) {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-child-jwt-token?email=${email}`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (this.me.company_type == "admin") {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&admin=true&admin_jwt_token=" + btoa(this.$store.state.auth.jwt);
        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), admin: true, admin_jwt_token: btoa(this.$store.state.auth.jwt) }});
      }
      else if (this.me.company_type == "agency") {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token) + "&owner=true&owner_jwt_token=" + btoa(this.$store.state.auth.jwt);
        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token), owner: true, owner_jwt_token: btoa(this.$store.state.auth.jwt) }});
      }
      else {
        // window.location = window.location.origin + '/login?alt=' + btoa(response.data.jwt_token);

        if (this.profile.company_type == 'user')
          this.$store.state.business_user = this.profile;

        this.$router.push({ name: 'login', query: {alt: btoa(response.data.jwt_token) }});
      }
    },
    backToAdmin() {
      let self = this
      this.$store.state.auth.admin = false
      this.$store.state.auth.owner = false

      setTimeout(function() {
        // window.location = window.location.origin + '/login?alt=' + self.$store.state.auth.admin_jwt_token;
        self.$router.push({ name: 'login', query: {alt: self.$store.state.auth.admin_jwt_token }});
      }, 10);
    },
    backToAgencyAdmin() {
      let self = this
      this.$store.state.auth.owner = false

      setTimeout(function() {
        self.$router.push({ name: 'login', query: {alt: self.$store.state.auth.owner_jwt_token }});
        // window.location = window.location.origin + '/login?alt=' + self.$store.state.auth.owner_jwt_token;
      }, 10);
    },
    clickedOutsideUserMenu() {
      this.showUserMenu = false
      this.showOnboarding = false
    },
    checkLocationsLinksDone() {
      let self = this
      if (!this.locations_links_done) {
        setTimeout(function() {
          try {
            var content = document.getElementsByClassName('locations-links')[0];
            var body = document.getElementsByClassName('v-select-list')[0];
            content.parentNode.removeChild(content);
            body.prepend(content);
            self.locations_links_done = true
          }
          catch (e) {}
        }, 50);
      }
    },
    commafy: function( num ) {
      var str = num.toString().split('.');
      if (str[0].length >= 5) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      }
      if (str[1] && str[1].length >= 5) {
          str[1] = str[1].replace(/(\d{3})/g, '$1 ');
      }
      return str.join('.');
    },
    getCreditsAvailable() {
      let available_credits = this.me.credits_monthly + this.me.credits_extra - this.me.credits_used

      if (available_credits < 0)
        return "Unlimited"

      return this.commafy(available_credits)
    },
    getLocalReconLink() {
      let lr_subdomain = "https://localrecon.reviewgrower.com/"

      if (process.env.NODE_ENV == 'development') {
        lr_subdomain = "http://localhost:8084/"
      }

      let extra_data = 'rg-agency-link?a=' + btoa(JSON.stringify(this.me));

      return lr_subdomain + extra_data;
    },
    sectionEnabled(section) {
      try {
        let sections = JSON.parse(this.profile.settings.sections);

        if (typeof(sections[section]) == "undefined") {
          return true;
        }
        
        if (!sections[section]) {
          return false;
        }
      }
      catch(e) {
      }


      return true;
    },
    displayNavigationItem(item) {
      if (this.$store.state.auth.owner || this.$store.state.auth.admin)
        return true;

      if (item.only_owner) {
        if (this.profile.company_type == 'user') {
          return false;
        }
        else {
          return true;
        }
      }

      if (!this.me.subscription)
        return false;
      
      if (this.me.subscription.product_details.limits.hide_sections === true && !this.me.subscription.product_details.limits.permissions[item.route])
        return false;

      if (this.profile.company_type == 'user') {
        return this.sectionEnabled(item.section);
      }

      return true;
    },
    hasGridTrackerEnabled() {
      return true;
      try {
        return this.me.subscription.product_details.limits.grid_tracker_enabled;
      }
      catch (e) {}

      return false;
    },
    shouldShowBilling() {
      if (localStorage.getItem("business_user")) {
        return false;
      }

      if (this.me.company_type == 'business' || this.me.company_type == 'location') {
        if (this.$agency.settings.is_omni)
          return false;
      }

      return (this.profile.company_type == 'agency' || (this.me.company_type == 'business' && this.me.parent_id && this.me.subscription));
    },

    async fetchMeStatsLocations() {
      await this.$store.dispatch('me/fetch')
      await this.$store.dispatch('locations/fetch')

      this.calculateFilteredLocations();

      await this.$store.dispatch('stats/fetch')

      console.log('this locations', this.locations)

      if (this.me.company_type != 'agency' && this.me.company_type != 'admin') {
        let locationFound = false;
        for (var i in this.locations) {
          if (this.me.uuid == this.locations[i].value) {
            locationFound = true;
          }
        }

        if (!locationFound) {
          this.switchLocation(this.locations[0].value);
        }
      }
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
      fetchingLocations: state => state.locations.fetchingLocations,
      locations: state => state.locations.locations,
      stats: state => state.stats.stats,
      fetchingStats: state => state.stats.fetchingStats,
      showHeaderAndNav: function() {
        if (this.$router.currentRoute.name == 'local_recon_widgets_create')
          return false;

        if (this.$router.currentRoute.name == 'local_recon_widgets_edit')
          return false;

        if (this.$router.currentRoute.name == 'local_recon_widgets_edit_token')
          return false;


        
        if (this.$router.currentRoute.name == 'widgets_create')
          return false;
        
        if (this.$router.currentRoute.name == 'widgets_edit')
          return false;
        
        if (this.$router.currentRoute.name == 'widgets_edit_token')
          return false;


        
        if (this.$router.currentRoute.name == 'contact_widgets_create')
          return false;

        if (this.$router.currentRoute.name == 'contact_widgets_edit')
          return false;

        if (this.$router.currentRoute.name == 'contact_widgets_edit_token')
          return false;


        
        if (this.$router.currentRoute.name == 'review-funnel')
          return false;



        if (this.$router.currentRoute.name == 'contact_form')
          return false;

        return true;
      }
    }),
    mini() {
        return (this.$vuetify.breakpoint.smAndDown) || this.toggleMini
    },
    buttonText() {
        return !this.$vuetify.theme.dark ? 'Go Dark' : 'Go Light'
    },
    hasAccess() {
      return true;
      if (this.me.company_type != 'agency') {
        if (window.location.pathname == '/plans') {
          this.$router.push('/');
          return false;
        }
      }

      // console.log('this.me.subscription.product_details.limits.permissions', this.me.subscription.product_details.limits.permissions)

      return this.me && (
        this.me.company_type == "admin" ||
        this.me.company_type == "agency" ||
        this.$store.state.auth.owner || 
        this.$store.state.auth.admin || 
        (
          (
            !this.me.subscription.product_details.limits.permissions.hasOwnProperty(window.location.pathname) || 
            this.me.subscription.product_details.limits.permissions[window.location.pathname])
          )
        );
    }
  },
  mounted() {
    this.fetchMeStatsLocations();

    // console.log(this.$store.state)

    if (this.$agency) {
      if (this.$agency.company_name == 'GMB Legend') {
        this.menu_items.business.push(
          { title:"Rank Tracker", section: '/rank-tracker', route:"/gmb-legend/rank-tracker", icon: "mdi mdi-order-numeric-ascending", only_owner: true },
          { title:"Backlinks Checker", section: '/backlinks-checker', route:"/gmb-legend/backlinks-checker", icon: "mdi mdi-link-variant", only_owner: true }
        )
      }
    }

    if (!this.$agency.settings.is_omni)
      this.menu_items.business.push({ title: "Grid Tracker", section: "/grid-tracker", route: "/grid-tracker-list", icon: "mdi mdi-map-marker-multiple-outline", only_owner: false });

    this.menu_items.business.push({ title: "Inbox", section: "/inbox", route: "/inbox", icon: "mdi mdi-message-processing", only_owner: false });
    this.menu_items.business.push({ title: "Users", section: '/users', route:"/users", icon: "mdi mdi-account-multiple", only_owner: true });

    let thisRoutePath = this.$router.currentRoute.path;

    let exploded = thisRoutePath.split('/');

    if (exploded.length > 0) {
      tryOpening();

      function tryOpening() {
        let aEl = $('div.v-list-item[sub-nav-parent="/' + exploded[1] + '"]');
        if (aEl.length > 0)
          aEl.click();
        else {
          setTimeout(function() {
            tryOpening();
          }, 50);
        }
      }
    }
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
}
</script>

<style lang="css" scoped>
.v-navigation-drawer__content a {
  text-decoration: none;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 20px;
}

.mx-auto.v-card, .v-list-item {
  height: 56px;
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.menu .router-link-exact-active {
  color: white !important;
}

.v-application ul, .v-application ol {
  padding-left: 0px;
}

.menu a {
  color: #c6f6d5;
}

.user-menu li i {
  width: 24px;
}

.locations-dropdown {
  width: 500px;
}

.header-right-items {
  float: left; margin-top: -31px; padding-right: 10px;
}

.mobile-navigation {
  /* position: absolute; */
  /* width: 255px;
  height: 100%; */
  /* display: none; */
  /* right: 0px; */
  /* margin-top: -20px; */
}

.mobile-navigation .v-btn__content i {
  font-size: 40px;
}

.mobile-navigation a {
  color: #757575;
  font-size: 15px;
  width: 100%;
  display: block;
  font-weight: bold;
}

.mobile-navigation a i {
  /* margin-right: 5px; */
  width: 24px;
}

@media screen and (max-width: 1023px) {
  .locations-dropdown {
    width: 275px;
  }
}

@media screen and (max-width: 767px) {
  .header-right-part {
    width: 100%;
  }
  .header-right-items {
    width: calc(100% - 37px);
  }
  .locations-dropdown {
    width: 100%;
    min-width: 60px;
  }
  .header-stats {
    display: none;
  }
  /* .me-icon {
    margin-top: 20px;
  } */

  .desktop-navigation {
    display: none;
  }

  .mobile-navigation {
    display: block;
  }

  .container {
    max-width: 100% !important;
  }
}

.user-menu {
  min-width: 300px !important;
}

.locations-links {
  padding-right: 20px;
  text-align: right;
  margin-top: 4px;
  z-index: 9;
  margin-bottom: 5px;
}

.locations-links {
  font-size: 14px;
}

.locations-links a {
  color: #1976d2;
}

.header-stats {
  color: #828282;
  margin-bottom: 6px;
  text-align: right;
}

.gravatar-pic {
  border-radius: 50%;
}

@media screen and (max-width: 900px) {
  .v-list-item__icon {
    padding-left: 0px !important;
  }
}

.rg-container {
  padding: 40px !important;
  padding-top: 25px !important;
}

.rg-sub-nav {

}
</style>
